import { connect } from 'react-redux';
import { Store, inputActions, suggestionsActions, asyncActions, searchParameterActions } from "dw_azsearchstore";
import * as redux from "redux";
import SearchBox from "../components/searchbox/SearchBox";
import { InputAction } from 'dw_azsearchstore/dist/actions/inputActions';
import { SuggestionsAction } from 'dw_azsearchstore/dist/actions/suggestionsActions';
import { FacetsAction } from 'dw_azsearchstore/dist/actions/facetsActions';
import { SearchParametersAction } from 'dw_azsearchstore/dist/actions/searchParametersActions';

interface SearchBoxContainerProps{
    ref: {}
}

function getReturnType<RT>(expression: (...params: any[])=>RT): RT {
    return {} as RT;
}          

declare type SearchDispatchActions = FacetsAction | SuggestionsAction | InputAction | SearchParametersAction

const mapDispatchToProps = (dispatch: redux.Dispatch<SearchDispatchActions>) => {
    return {
        onInputChange: (input: string) => {
            dispatch(inputActions.setInput(input));
        },
        suggest: () => {
            dispatch(asyncActions.suggest);
        },
        clearSuggestions: () => {
            dispatch(suggestionsActions.clearSuggestions());
        },
        commenceSearch: () => {
            dispatch(searchParameterActions.updateSearchParameters({skip: 0}));
            dispatch(asyncActions.fetchSearchResultsFromFacet);
            window.scrollTo({top: 0, behavior: "smooth"});
        }
    }
}

function mapStateToProps(state: Store.SearchState, ownProps: SearchBoxContainerProps) {
    return {
        ref: {},
        input: state.parameters.input,
        preTag: state.parameters.suggestionsParameters.highlightPreTag,
        postTag: state.parameters.suggestionsParameters.highlightPostTag,
        suggestions: state.suggestions.suggestions,
    }
}

export const stateProps = getReturnType(mapStateToProps);
export const dispatchProps = getReturnType(mapDispatchToProps);

export type PropsType = typeof stateProps & typeof dispatchProps;
type State = {};

const SearchBoxContainer = connect(mapStateToProps, mapDispatchToProps)(SearchBox);

export { SearchBoxContainer }